/* eslint-disable camelcase */
export const accordionLevel1 = '1';
export const accordionLevel2 = '2';
export const accordionLevel3 = '3';

export const featureType = 'features';
export const customerType = 'customers';
export const productType = 'Products';
export const trialPeriodsType = 'TrialPeriods';
export const loginHistoryType = 'LoginHistoryType';
export const hardlocks = 'Hardlocks';
export const hardlockTypes = 'HardlockTypes';

export const CM_CLIENT_v2 = "2.0";
export const CM_CLIENT_v2_1 = "2.1";
export const CM_CLIENT_v2_2 = "2.2";
